import store from "../store/store.js";
import router from "../router/router.js";

export const auditConfig = {
    baseUrl: "https://clubkioscoapi.azurewebsites.net/api/"
    //baseUrl: "https://clubkioscoapitest.azurewebsites.net/api/"
};


function GetHeaders() {
    // jwt token
    let token = store.state.token;

    if (token) {
        return {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
        };
    } else {
        return {
            'Content-Type': 'application/json'
        };
    }
}
export async function executeAction(actionType, path, bodyData, withHeaders) {

    store.commit("setOverlay", true);
    let data = {};
    const requestOptions = {
        method: `${actionType}`,
        headers: withHeaders ? GetHeaders() : {
            'Content-Type': 'application/json'
        },
        body: bodyData === null ? bodyData : JSON.stringify(bodyData)
    };
    await fetch(`${auditConfig.baseUrl}${path}`, requestOptions)
        .then(async response => {
            if (!response.ok) {
                switch (response.status) {
                    case 404:
                        data.errorMessage = "Ruta de API no encontrada";
                        break;
                    case 401:
                    case 403:
                        router.push({
                            path: "/"
                        });
                        break;
                }
                data.result = false;
                data.payload = null;
                data.errorCode = 0;
            } else {
                data = await response.json();
            }

        })
        .catch(error => {
            data.result = false;
            data.errorMessage = error;
            data.payload = null;
            data.errorCode = 0;
        });
    store.commit("setOverlay", false);
    return data;
}

/**EJEMPLO DE USO 
 async retrieveUsers() {
     await executeAction("GET", "User/All", null,false).then(response => {
         if (!response.result) {
             this.alert_error = true;
             this.errorMessage = response.errorMessage;
             setTimeout(() => {
                 this.alert_error = false;
                 this.errorMessage = '';
             }, 10000);
         } else {
             this.users = JSON.parse(response.payload);

         }
     });
 }

  async retrieveUsers() {
     await executeAction("GET", "User/All", null,false).then(response => {
         if (!response.result) {
             if(response.errorCode === 5000)
             {
                  //pantalla para recuperar xml y pdf  
             }
             this.alert_error = true;
             this.errorMessage = response.errorMessage;
             setTimeout(() => {
                 this.alert_error = false;
                 this.errorMessage = '';
             }, 10000);
         } else {
             this.users = JSON.parse(response.payload);

         }
     });
 }
 **/